import { useState } from "react";
import { Check, Pencil } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const EcartNote = ({ txId, explication, note, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(note || "");
  const save = async () => {
    try { await api.put(`/transactions/${txId}/note`, { note: val }); toast.success("Note enregistrée"); setEdit(false); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-[280px] text-xs" data-testid={`ecart-note-${txId}`}>
      {explication && <p className="text-slate-600" data-testid={`ecart-explication-${txId}`}>{explication}</p>}
      {edit ? (
        <div className="mt-1 flex gap-1">
          <Input autoFocus value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} className="h-7 text-xs" placeholder="Votre note…" data-testid={`ecart-note-input-${txId}`} />
          <button onClick={save} className="rounded px-1.5 text-emerald-700 hover:bg-emerald-50" data-testid={`ecart-note-save-${txId}`}><Check className="h-3.5 w-3.5" /></button>
        </div>
      ) : (
        <button onClick={() => setEdit(true)} className="mt-1 flex items-start gap-1 text-left text-slate-500 hover:text-emerald-700" data-testid={`ecart-note-edit-${txId}`}>
          <Pencil className="mt-0.5 h-3 w-3 shrink-0" />
          {note ? <span className="text-slate-800"><b>Note :</b> {note}</span> : <span>Ajouter une note</span>}
        </button>
      )}
    </div>
  );
};
